<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Workflows'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (loaded) {
      <tidy-row>
        <tidy-text
          [header]="'Request Workflow(s)'" />
      </tidy-row>
      <form [formGroup]="form" novalidate action="#">
        <tidy-row class="extra-bottom-padding">
          <tidy-textarea
            label="Describe any workflows you'd like to automate"
            [icon]="'assets/svg/information-circle.svg'"
            [form]="form.get('workflowRequest')"
            formControlName="workflowRequest" />
        </tidy-row>
      </form>
      <tidy-row>
        <tidy-text
          [header]="'Common Templates'" />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        <tidy-text
          [body]="'We selected some popular templates for you. Select more or customize the ones you want.'" />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        @for (template of workflowTemplates; track template) {
          <tidy-card class="card-checkbox" [ngClass]="{'selected-card-checkbox': template.isSelected}" (click)="selectTemplate(template)">
            <div style="display: flex; align-items: center;">
              <tidy-text
                [header]="template?.name" />
            </div>
            <tidy-row>
              <tidy-text
                [body]="template?.description" />
            </tidy-row>
          </tidy-card>
        }
      </tidy-row>
      <tidy-button
        [text]="'Save'"
        [action]="boundSaveWorkflows"
        class="primary" />
    }

    @if (!loaded) {
      <ion-skeleton-text animated="true" style="width: 100%; height: 557px" />
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
